import { render, staticRenderFns } from "./QuestionContent.vue?vue&type=template&id=23646b70&"
import script from "./QuestionContent.vue?vue&type=script&lang=js&"
export * from "./QuestionContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports